import ApiClient from "../helpers/ApiClient";

const baseRecompensasEndpoint = (cnpj) => `/gestao/empresa/${cnpj}/recompensas`;

const listRecompensas = (cnpj) =>
  ApiClient.apiClientDef.get(baseRecompensasEndpoint(cnpj));

const postRecompensas = (cnpj, data) =>
  ApiClient.apiClientDef.post(baseRecompensasEndpoint(cnpj), data);

const deleteRecompensa = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(`${baseRecompensasEndpoint(cnpj)}/${uid}`);

const RecompensasApiClient = {
  listRecompensas,
  postRecompensas,
  deleteRecompensa,
};
export default RecompensasApiClient;
